import React from "react";
import EditorEditIcon from "@atlaskit/icon/glyph/editor/edit";

import { styled } from "@mui/material/styles";

import { COLOR_WHITE, COLOR_PICKLE_BLUEWOOD } from "../../constants/styles";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { HelpTooltip, TooltipURL } from "../HelpTooltip";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { UserNotificationEditModal } from "../UserNotificationEditModal";
import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";
import { ExternalLink } from "../../common/component/NavLink";

export interface IProps {
  title: string;
  titleTooltipText: string;
  text?: string;
  urlHelpTooltip?: TooltipURL;
  isDisabled?: boolean;
  onUpdateClick: (text: string) => void;
}

const StyledContainer = styled(Grid)`
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 3px;
`;

export const ConfirmationContainer: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();

  const openEditModal = () => setIsOpen(true);

  const customTooltipText = <>
     <Grid item xs={12}>
      <Typography color={COLOR_WHITE} sx={{ fontSize: "14px !important" }}>
        {props.text}
      </Typography>
    </Grid>
    {props.urlHelpTooltip && (
      <Grid item xs={12} mt={2}>
      <Typography color={COLOR_WHITE} sx={{ fontSize: "14px !important" }}>
        <ExternalLink name={props.urlHelpTooltip.text} to={props.urlHelpTooltip.link} />
      </Typography>
    </Grid>
    )}
  </>;

  return (
    <StyledContainer container>
      <Grid item xs={12} bgcolor={COLOR_PICKLE_BLUEWOOD} px={1.5} py={2.5}>
        <Typography fontSize={16} fontWeight={600} color={COLOR_WHITE}>
          <HelpTooltip title={props.title} customText={customTooltipText}>
            {props.title}
          </HelpTooltip>
        </Typography>
      </Grid>
      <Grid item xs={12} px={1.5} py={2.5}>
        {props.text && <Box dangerouslySetInnerHTML={{ __html: props.text }} mb={2.5} />}
        <ReadOnlyWrapper>
          <Button appearance="primary" onClick={openEditModal} iconBefore={<EditorEditIcon label="edit" />} isDisabled={isSuperAdminRead() || props.isDisabled}>
            Edit
          </Button>
        </ReadOnlyWrapper>
      </Grid>
      <UserNotificationEditModal textToEdit={props.text} onSave={props.onUpdateClick} />
    </StyledContainer>
  );
};
